
import path from 'path'
import { computed, defineComponent, PropType } from 'vue'
import { useStore } from '@/store/index'
import { RouteRecordRaw } from 'vue-router'
import { isExternal } from '@/utils/validator'
import ItemLink from './ItemLink.vue'

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<RouteRecordRaw>,
            required: true
        },
        isCollapse: {
            type: Boolean,
            required: false
        },
        basePath: {
            type: String,
            required: true
        }
    },
    components: {
        ItemLink
    },
    setup(props) {
        const store = useStore()

        // 菜单提醒
        const menuWarning = computed(() => {
            return store.state.user.menuWarning
        })

        const alwaysShowRootMenu = computed(() => {
            if (props.item.meta && props.item.meta.alwaysShow) {
                return true
            } else {
                return false
            }
        })

        const showingChildNumber = computed(() => {
            if (props.item.children) {
                const showingChildren = props.item.children.filter((item) => {
                    if (item.meta && item.meta.hidden) {
                        return false
                    } else {
                        return true
                    }
                })
                return showingChildren.length
            }
            return 0
        })

        const theOnlyOneChild = computed(() => {
            if (showingChildNumber.value > 1) {
                return null
            }
            if (props.item.children) {
                for (const child of props.item.children) {
                    if (!child.meta || !child.meta.hidden) {
                        return child
                    }
                }
            }
            // If there is no children, return itself with path removed,
            // because this.basePath already conatins item's path information
            return { ...props.item, path: '' }
        })

        const resolvePath = (routePath: string) => {
            if (isExternal(routePath)) {
                return routePath
            }
            if (isExternal(props.basePath)) {
                return props.basePath
            }
            return path.resolve(props.basePath, routePath)
        }

        return {
            alwaysShowRootMenu,
            showingChildNumber,
            theOnlyOneChild,
            resolvePath,
            menuWarning
        }
    }
})
